import { ia, iaRa } from 'lib/helpers/utility';

// export const createQueryFilters = (filters, status) => {
//   const mappedFilters = mapValues(filters);
//   const result = {};

//   Object.entries(mappedFilters).forEach(([key, value]) => {
//     if (Array.isArray(value)) {
//       result[key] = {
//         formula: filters[key].formula || 'is any of',
//         values: value.map((item) => item.value)
//       };
//       return;
//     }

//     if (typeof value === 'object') {
//       result[key] = {
//         formula: filters[key].formula || 'is any of',
//         values: value
//       };
//       return;
//     }

//     result[key] = { formula: filters[key].formula || 'is any of', values: value };
//   });

//   if (status) {
//     result.status = status;
//   }

//   return Object.entries(result).reduce((acc, [key, value]) => {
//     if (value === null || value === undefined) {
//       return acc;
//     }
//     return { ...acc, [key]: value };
//   }, {});
// };

export const createQueryFilters = (filters, status) => {
  const result = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (!ia(value)) return;
    const mappedFilters = iaRa(value);

    const filteredItems = mappedFilters
      .map((item) => {
        if (!item.values) return null;

        if (ia(item.values)) {
          return {
            formula: item.formula || 'is',
            values: item.values.map((v) => v.value)
          };
        }

        return { formula: item.formula, values: item.values };
      })
      .filter(Boolean);

    if (filteredItems.length > 0) {
      result[key] = filteredItems;
    }
  });

  if (status) {
    result.status = [{ values: [status], formula: 'is' }];
  }

  return result;
};
